import { render, staticRenderFns } from "./SidebarSettingsMobile.vue?vue&type=template&id=dcdae5a8&"
import script from "./SidebarSettingsMobile.vue?vue&type=script&lang=js&"
export * from "./SidebarSettingsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports